import { MobileTooltip } from '../components/Tooltip/MobileTooltip';
import { Tooltip } from '../components/Tooltip/Tooltip';
import { useViewport } from './useViewport';
import { FaqHeading, MobileFaqHeading } from '../components/Faq/FaqHeading';
import { TitleAndSubTitle } from '../components/TitleAndSubTitle/TitleAndSubTitle';
import { MobileTitleAndSubTitle } from '../components/TitleAndSubTitle/MobileTitleAndSubTitle';
import { ChargeDetail } from '../components/ChargeDetails/ChargeDetail';
import { MobileChargeDetail } from '../components/ChargeDetails/MobileChargeDetail';

const desktopCompBank = {
  Tooltip,
  FaqHeading,
  TitleAndSubTitle,
  ChargeDetail,
};

const mobileCompBank = {
  Tooltip: MobileTooltip,
  FaqHeading: MobileFaqHeading,
  TitleAndSubTitle: MobileTitleAndSubTitle,
  ChargeDetail: MobileChargeDetail,
};

export const useResponsiveComponents = () => {
  const { currentBreakpoint } = useViewport();

  return [
    currentBreakpoint.isMobile || currentBreakpoint.isTablet
      ? mobileCompBank
      : desktopCompBank,
  ];
};
